<div data-testid="entities-trend" class="entities-trend">
  <header class="entities-trend__header">
    <div class="entities-trend__titles">
      <h4 class="entities-trend__title">{{ cardTitle }}</h4>
      <p class="entities-trend__description">{{ description }}</p>
      <p *ngIf="numbersText" data-testid="entities-trend-numbers" class="entities-trend__numbers">{{ numbersText }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="entities-trend-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or change the filters." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && isEmpty" data-testid="entities-trend-empty" icon="fa-regular fa-sitemap"
                             [title]="emptyTitle"></app-admin-dashboard-empty>
  <div *ngIf="loaded && !failed && !isEmpty" #chart data-testid="entities-trend-chart" class="entities-trend__chart"></div>
  <div *ngIf="!loaded" class="entities-trend__chart"></div>
  <ng-container *ngIf="loaded && !failed && !isEmpty">
    <p *ngFor="let note of notes" data-testid="entities-trend-note" class="entities-trend__note">{{ note }}</p>
  </ng-container>
</div>
